import { getPageTitle, getDefaultPageTitle } from "../results/selectors";

export const pageTitleMiddleware = () => store => next => action => {
  
  next(action);

  if(action.meta && action.meta.updatePageTitle){    
    const state = store.getState();
    const defaultPageTitle = getDefaultPageTitle(state);
    const pageTitle = getPageTitle(state);

    document.title = pageTitle || defaultPageTitle;
  }
}